import React, {forwardRef, useEffect, useRef, useState } from 'react'
import MaterialTable from 'material-table'
import { convertFirestoreTimestampToDate, convertDateToFirestoreTimestamp, convertDateStringToFirestoreTimestamp } from "../common/FirestoreUtilities"

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

export default function GreasingsTabContent(props) {

    const [greasings, setGreasings] = useState(undefined)
    const greasingsQueryRef = useRef(undefined)

    useEffect(() => {
        greasingsQueryRef.current = props.db.collection('greasings').where("truck", "==", props.truck)

        let greasingsUnsubscribe = greasingsQueryRef.current
          .onSnapshot(querySnapshot => {
            const tempGreasingsWithRefs = querySnapshot.docs.map(greasingRef => {
                const data = greasingRef.data()
                data.date = convertFirestoreTimestampToDate(props.firebase, data.date)
                return {ref: greasingRef.id, ...data}
            })
            setGreasings(tempGreasingsWithRefs)
          })
        return () => {
            greasingsUnsubscribe()
        }
    }, [props.truck])

    return (
        <MaterialTable
            icons={tableIcons}
            title="Greasings"
            columns={[
                { field: 'ref', hidden: true },
                { 
                    title: 'Date', 
                    field: 'date',
                    type: 'date',
                    customFilterAndSearch: (term, rowData) => {
                        return this.testDateInCustomFilterAndSearch(term, rowData.date)
                    } 
                },
                { title: 'Mileage', field: 'mileage', type: 'numeric' }
            ]}
            data={greasings}  
            options={{
                filtering: true,
                search: true,
                sorting: true,
                paging: false,
                addRowPosition: 'first'
            }}
            editable={{
                onRowAdd: async newData => {
                    const dataWithoutRef = {...newData}
                    delete dataWithoutRef.ref
                    dataWithoutRef.truck = props.truck
                    
                    // Convert date to Firestore timestamp
                    if (dataWithoutRef.date) {
                        dataWithoutRef.date = convertDateToFirestoreTimestamp(props.firebase, dataWithoutRef.date)
                    }
                    
                    props.db.collection('greasings').add(dataWithoutRef).catch(err => {
                        alert(err)
                    })
                },
                onRowUpdate: async (newData, oldData) =>{
                    const dataWithoutRef = {...newData}
                    delete dataWithoutRef.ref
                    delete dataWithoutRef.truck // Don't update truck reference
                    
                    // Convert date to Firestore timestamp
                    // Note: Using convertDateStringToFirestoreTimestamp instead of convertDateToFirestoreTimestamp
                    // because MaterialTable passes dates as strings to the update handler
                    if (dataWithoutRef.date) {
                        dataWithoutRef.date = convertDateStringToFirestoreTimestamp(props.firebase, dataWithoutRef.date)
                    }
                    
                    props.db.collection('greasings').doc(oldData.ref).update(dataWithoutRef).catch(err => {
                        alert(err)
                    })
                }
            }}
        />
    )

}